<template>
  <BaseSection>
    <template #header>
      <BaseTitle
        tag="h1"
        size="l"
        is-medium
        data-animation="fadeInBottom"
        data-animation-delay="100"
        text="Бесплатная экспресс&#8209;оценка существующего курса"
      />
    </template>
    <template #content>
      <TheEvaluationForm class="section__form" data-animation="fadeIn" data-animation-delay="300" />
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import TheEvaluationForm from '@/components/TheEvaluationForm.vue';

export default {
  name: 'EvaluationPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    TheEvaluationForm,
  },
};
</script>
